/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RuleSetMigrationDto
 */
export interface RuleSetMigrationDto {
    /**
     * 
     * @type {string}
     * @memberof RuleSetMigrationDto
     */
    oldRulesetId: string;
    /**
     * 
     * @type {string}
     * @memberof RuleSetMigrationDto
     */
    newRulesetId: string;
}

/**
 * Check if a given object implements the RuleSetMigrationDto interface.
 */
export function instanceOfRuleSetMigrationDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "oldRulesetId" in value;
    isInstance = isInstance && "newRulesetId" in value;

    return isInstance;
}

export function RuleSetMigrationDtoFromJSON(json: any): RuleSetMigrationDto {
    return RuleSetMigrationDtoFromJSONTyped(json, false);
}

export function RuleSetMigrationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RuleSetMigrationDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'oldRulesetId': json['oldRulesetId'],
        'newRulesetId': json['newRulesetId'],
    };
}

export function RuleSetMigrationDtoToJSON(value?: RuleSetMigrationDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'oldRulesetId': value.oldRulesetId,
        'newRulesetId': value.newRulesetId,
    };
}

